/**
 * AWS Cognito configuration for staging
 * passwordPolicy must match your Cognito User Pool's password policy
 */
export default {
  useCognitoAuth: true,
  userPoolId: 'us-east-1_7GFaW20Nu',
  clientId: '7lo9ibq4uo3ltcbf54hod8f4fm',
  region: 'us-east-1',
  passwordPolicy: {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSymbolsOrSpace: true,
    noLeadingTrailingSpace: true
  }
}
